import { render, staticRenderFns } from "./NFlooter.vue?vue&type=template&id=3511be6a&scoped=true"
import script from "./NFlooter.vue?vue&type=script&lang=js"
export * from "./NFlooter.vue?vue&type=script&lang=js"
import style0 from "./NFlooter.vue?vue&type=style&index=0&id=3511be6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3511be6a",
  null
  
)

export default component.exports